import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _contacts = [];
let _stats = {};

let ContactStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _contacts.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _contacts.find(function(e) { return e !== undefined && e.id == id; });
    },
    add: function(entity) {
        if (!!entity && !!entity.id) {
            var index = _contacts.findIndex(function(e) { return e !== undefined && e.id == entity.id; });
            if (0 <= index) {
                _contacts[index] = entity;
            } else {
                _contacts.push(entity);
            }
        }
    },
    delete: function(id) {
        var index = _contacts.findIndex(function(e) { return e !== undefined && e.id == id; });
        if (0 <= index) {
            delete _contacts[index];
        }
    },
    getStats: function() {
        return _stats;
    },

});

ContactStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.CONTACT_LIST:
            action.data.forEach(ContactStore.add);
            ContactStore.emitChange();
            break;

        case ActionTypes.CONTACT_LIST_ERROR:
            ContactStore.emitChange();
            break;

        case ActionTypes.CONTACT_INFO:
            ContactStore.add(action.data);
            ContactStore.emitChange();
            break;

        case ActionTypes.CONTACT_INFO_ERROR:
            ContactStore.emitChange();
            break;

        case ActionTypes.CONTACT_SAVE:
            ContactStore.add(action.data);
            ContactStore.emitChange();
            break;

        case ActionTypes.CONTACT_UPDATE:
            ContactStore.add(action.data);
            ContactStore.emitChange();
            break;

        case ActionTypes.CONTACT_DELETE:
            if (!!action.data.deleted && !!action.data.id) {
                ContactStore.delete(action.data.id);
            }
            ContactStore.emitChange();
            break;

        default:
            break;
    }

});

export default ContactStore;
